export const UMB_DATA_TYPE_TREE_ITEM_CHILDREN_COLLECTION_REPOSITORY_ALIAS =
	'Umb.Repository.DataType.TreeItemChildrenCollection';
